@if(isSidebarOpen){
<div class="overlay"></div>
}
<div class="sidebar" [class.sidebar-open]="isSidebarOpen">
  <div class="hamburger-btn" (click)="toggleSidebar()">
    <i
      class="bi"
      [class.bi-list]="!isSidebarOpen"
      [class.bi-x]="isSidebarOpen"
    ></i>
  </div>

  <!-- Logo -->
  <div class="logo-container">
    <a routerLink="/inicio">
      <img src="./assets/logo-w.svg" alt="Seguros Reservas" class="logo" />
    </a>
  </div>

  <!-- Menú principal -->
  <nav class="menu">
    @for (item of menuItems; track item.id) {
    <div class="menu-dropdown">
      <button
        class="menu-item"
        [class.active]="activeMenu === item.description"
        (click)="toggleSubmenu(item.description)"
        [routerLink]="
          !item.subMenu || item.subMenu.length === 0
            ? ['/inicio', item.route]
            : null
        "
      >
        <div class="icon" [style.background-image]="item.iconRoute"></div>
        <span>{{ item.description }}</span>
        @if (item.subMenu && item.subMenu.length > 0) {
        <i
          class="bi bi-chevron-down"
          [class.rotate]="activeMenu === item.description"
        ></i>
        }
      </button>

      <div class="submenu" [class.show]="activeMenu === item.description">
        @for (subItem of item.subMenu; track subItem.id) { @if (subItem.route) {
        <a
          [routerLink]="[subItem.route]"
          class="submenu-item"
          [class.active]="activeSubmenu === subItem.description"
          (click)="toggleSubmenu(item.description, subItem.description)"
        >
          {{ subItem.description }}
        </a>
        } @if (subItem.cotizador) {
        <a
          href="javascript:void(0)"
          class="submenu-item"
          [class.active]="activeSubmenu === subItem.description"
          (click)="abrirCotizador(subItem.cotizador)"
        >
          {{ subItem.description }}
        </a>
        } }
      </div>
    </div>
    }
  </nav>
  <!-- Menú informativo -->

  <nav class="menu-2">
    @for (infoitem of infomenuItems; track infoitem.id) {
    <div class="menu-dropdown">
      <button
        class="menu-item"
        [class.active]="activeMenuInfo === infoitem.description"
        (click)="toggleSubmenu(infoitem.description)"
        [routerLink]="infoitem.externalUrl ? null : infoitem.route"
      >
        <div
          class="icon-info"
          [style.background-image]="infoitem.iconRoute"
        ></div>
        <span>{{ infoitem.description }}</span>
      </button>
    </div>
    }
  </nav>

  <!-- Redes Sociales -->
  <div class="social-media">
    <div class="circle">
      <a href="https://www.facebook.com/segurosreservas/" target="_blank"
        ><i class="bi bi-facebook"></i
      ></a>
    </div>
    <div class="circle">
      <a href="https://www.instagram.com/segurosreservasrd/" target="_blank"
        ><i class="bi bi-instagram"></i
      ></a>
    </div>
    <div class="circle">
      <a href="https://www.x.com/segurosreservas/" target="_blank"
        ><i class="bi bi-twitter-x"></i>
      </a>
    </div>
    <div class="circle">
      <a href="https://www.youtube.com/@SegurosReservas/" target="_blank"
        ><i class="bi bi-youtube"></i
      ></a>
    </div>
  </div>
</div>
